// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".anime {\n  animation: girarInfinitamente 8s cubic-bezier(0.75, 0.17, 0.52, 1.04) infinite;\n}\n@keyframes girarInfinitamente {\n0% {\n    transform: rotate(0deg);\n}\n54.5%, 100% {\n    transform: rotate(90deg);\n}\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
